/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form } from 'semantic-ui-react'

export default class DynamicFeeStatusField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props

    const options = [{ key: 1, text: 'Draft', value: false }, { key: 2, text: 'Publish', value: true }]

    return (
      <Form.Select
        required
        fluid
        label="Status"
        options={options}
        placeholder="Publish/Draft"
        onChange={(e, data) => onChange(data.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/dynamicFeeStatusField.js